import { render, staticRenderFns } from "./CommunicationThread.vue?vue&type=template&id=438f3931&scoped=true"
import script from "./CommunicationThread.vue?vue&type=script&lang=js"
export * from "./CommunicationThread.vue?vue&type=script&lang=js"
import style0 from "./CommunicationThread.vue?vue&type=style&index=0&id=438f3931&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438f3931",
  null
  
)

export default component.exports